import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const ExploreProfile = ({userId, profileId}) => {
    return (
        <div className="profile-container"></div>
    );
};

export default ExploreProfile;